// This file was generated using `pay js:run gql-v1 --type=fragment --name=PersonRequirementsArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiAccountRequirementsErrorCodeEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment PersonRequirementsArkFragment on OpenapiPersonRequirements {
    alternatives {
      alternative_fields_due
      original_fields_due
    }
    currently_due
    errors {
      code
      reason
      requirement
      suggestion {
        message
      }
    }
    eventually_due
    past_due
    pending_verification
  }
`;

export const personRequirementsArkFragment: PersonRequirementsArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type PersonRequirementsArkFragmentData = {
  readonly __typename: 'OpenapiPersonRequirements';
  readonly currently_due: ReadonlyArray<string>;
  readonly eventually_due: ReadonlyArray<string>;
  readonly past_due: ReadonlyArray<string>;
  readonly pending_verification: ReadonlyArray<string>;
  readonly alternatives: ReadonlyArray<{
    readonly __typename: 'OpenapiAccountRequirementsAlternative';
    readonly alternative_fields_due: ReadonlyArray<string>;
    readonly original_fields_due: ReadonlyArray<string>;
  }> | null;
  readonly errors: ReadonlyArray<{
    readonly __typename: 'OpenapiAccountRequirementsError';
    readonly code: OpenapiAccountRequirementsErrorCodeEnum;
    readonly reason: string;
    readonly requirement: string;
    readonly suggestion: {
      readonly __typename: 'OpenapiAccountErrorSuggestion';
      readonly message: string;
    } | null;
  }>;
};

export type PersonRequirementsArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const personRequirementsArkFragmentPermissions = {} as const;

doc.permissions = personRequirementsArkFragmentPermissions;

export type PersonRequirementsArkFragmentPermissions = V1PermissionToken<
  typeof personRequirementsArkFragmentPermissions
>;

export type PersonRequirementsArkFragmentDocument = GraphQlDocument<
  PersonRequirementsArkFragmentData,
  PersonRequirementsArkFragmentVariables,
  PersonRequirementsArkFragmentPermissions
>;
